import { useEffect, useState } from "react";
import { Loader } from "@/components/site/Loader";
import { preloadHeroScrub } from "@/lib/heroMedia";
import { Navbar } from "@/components/site/Navbar";
import { HeroScrub } from "@/components/site/HeroScrub";
import { Problem } from "@/components/site/Problem";
import { Benefits } from "@/components/site/Benefits";
import { WhatIs } from "@/components/site/WhatIs";
import { Products } from "@/components/site/Products";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function Landing() {
  const [loading, setLoading] = useState(true);
  // Kick off the hero video download immediately; the Loader waits for it.
  // Reduced-motion users get the static hero, so don't gate (or fetch) there.
  const [heroReady] = useState(() =>
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? null
      : preloadHeroScrub()
  );

  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  return (
    <>
      <Loader onComplete={() => setLoading(false)} waitFor={heroReady} />
      <Navbar />
      <main>
        <HeroScrub />
        <Problem />
        <Benefits />
        {/* <WhatIs /> — hidden, not deleted. Πες "φέρ' το πίσω" για να το ξαναδείξουμε */}
        <Products />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </>
  );
}
